import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
export function Layout({ children, isLoading }) {
    return (React.createElement("div", { className: classnames('register-step-layout', { 'register-step-layout--is-loading': isLoading }) }, children));
}
export function LayoutTitle({ text }) {
    return (React.createElement("h1", { className: 'register-step-layout__title' }, text));
}
export function LayoutDescription({ text }) {
    return (React.createElement("p", { className: 'register-step-layout__description' }, text));
}
export function LayoutFooter({ children, positionShouldChange }) {
    const [isFixed, setIsFixed] = useState(positionShouldChange);
    useEffect(() => {
        const onscroll = () => {
            const isReachingBottom = window.innerHeight +
                document.documentElement.scrollTop >= document.documentElement.offsetHeight - 50;
            const shouldBeFixed = window.innerHeight +
                document.documentElement.scrollTop < document.documentElement.offsetHeight - 200;
            if (isReachingBottom === true && isFixed)
                setIsFixed(false);
            if (shouldBeFixed === true && !isFixed)
                setIsFixed(true);
        };
        if (positionShouldChange)
            window.addEventListener('scroll', onscroll);
        return () => {
            window.removeEventListener('scroll', onscroll);
        };
    }, [isFixed]);
    return (React.createElement("div", { className: classnames('register-step-layout__footer', { 'is-fixed': isFixed }) }, children));
}
